import * as ApiBase from '../../APIBase'
import receiveInitalStateSuccess, { loadingMerchant } from './index'

import { checkUserLogin } from '../../App/checkLogin'
import { getCookieToken } from '../../utils/cookieToken'
import { getAccessToken } from '../../App/getAccessToken'

const fetchMerchantInfo = () => async (dispatch, getState) => {
  dispatch(loadingMerchant(true))

  // IF ID is present in Store, which means its a redirection so no need to fetch again
  const merchantId = getState().merchant.id

  const { host } = window.location
  const url = `/merchant/init?domain=${host}`

  if (merchantId) {
    dispatch(loadingMerchant(false))
  } else {
    const accessToken = getCookieToken()
    let newtoken = ''
    await dispatch(getAccessToken(accessToken))
    if (!accessToken) {
      newtoken = getState().user.accessToken
    }

    const initState = await ApiBase.get(url, {}, accessToken || newtoken)

    dispatch(receiveInitalStateSuccess(initState))

    if (initState.canonical_name && (accessToken || newtoken)) {
      dispatch(checkUserLogin(initState.canonical_name))
    }
  }
}

export default fetchMerchantInfo
